export function updateArticleStatus({
  articleID,
  action,
  desiredState,
  user,
  refs, // refs: { currentArticle, isRead, isSaved, isLiked, isDisliked }
  tagEvent,
  updateStorage,
}) {
  const normalizedAction = action === 'favorite' ? 'saved' : action;
  if (!user.training[articleID]) {
    user.training[articleID] = {
      read: false,
      saved: false,
      like: false,
      dislike: false,
    };
  }

  const status = { ...user.training[articleID] };
  status.saved = status.saved ?? status.favorite ?? false;
  delete status.favorite;

  switch (normalizedAction) {
    case 'read':
      status.read = desiredState ?? !status.read ?? true;
      break;

    case 'saved':
      status.saved = desiredState ?? !status.saved;
      break;

    case 'like':
      status.like = desiredState ?? !status.like;
      if (status.like) {
        status.dislike = false;
        status.read = true;
      }
      break;

    case 'dislike':
      status.dislike = desiredState ?? !status.dislike;
      if (status.dislike) {
        status.like = false;
        status.read = true;
      }
      break;
  }

  // update if active article
  if (articleID === refs.currentArticle.id) {
    refs.isRead.value = status.read;
    refs.isSaved.value = status.saved;
    refs.isLiked.value = status.like;
    refs.isDisliked.value = status.dislike;
  }

  // tag affirmative events
  if (status[normalizedAction]) {
    tagEvent({ where: 'article_reactions', what: normalizedAction });
  }

  // stash update
  user.training[articleID] = status;
  updateStorage(user, true, 'articleStatus', articleID);
}
